import toastCaller from '../toastCaller'
import dayjs from 'dayjs'

export const getFileNameParts = (
	name: string
): { base: string; ext: string } => {
	const lastDotIndex = name.lastIndexOf('.')
	if (lastDotIndex === -1) return { base: name, ext: '' }
	return {
		base: name.substring(0, lastDotIndex),
		ext: name.substring(lastDotIndex),
	}
}

export const getAvailableName = (
	currentName: string,
	existingNames: Set<string>,
	isFolder = false,
	withWarning = false
): string => {
	const { base, ext } = getFileNameParts(currentName)
	const cleanBase = base.replace(/\s\(\d+\)$/, '')

	if (!existingNames.has(currentName)) return currentName

	let counter = 1
	let newName

	// eslint-disable-next-line no-constant-condition
	while (true) {
		newName = isFolder
			? `${cleanBase} (${counter})`
			: `${cleanBase} (${counter})${ext}`
		if (!existingNames.has(newName)) break
		counter++
	}

	if (withWarning) {
		toastCaller({
			type: 'warning',
			message: `The ${
				isFolder ? 'folder' : 'file'
			} "${currentName}" already exists!\nIt will be renamed to "${newName}".`,
		})
	}

	return newName
}

export const generateUniqueName = (
	currentName: string,
	isFolder = false
): string => {
	const { base, ext } = getFileNameParts(currentName)
	const timestamp = new Date().toISOString().replace(/[-:.TZ]/g, '')
	return isFolder ? `${base} ${timestamp}` : `${base} ${timestamp}${ext}`
}

export const getSafeFileNameWithDate = (
	originalName: string,
	isFolder = false,
	withWarning = false
): string => {
	const timestamp = dayjs().format('YYYY-MM-DD_HH-mm-ss')

	let name = originalName

	name = name.replace(/ \\(\\d{4}-\\d{2}-\\d{2}_\\d{2}-\\d{2}-\\d{2}\\)/g, '')

	let newName: string

	if (isFolder) {
		newName = `${name} (${timestamp})`
	} else {
		const lastDotIndex = name.lastIndexOf('.')
		if (lastDotIndex === -1) {
			newName = `${name} (${timestamp})`
		} else {
			const base = name
				.slice(0, lastDotIndex)
				.replace(/ \\(\\d{4}-\\d{2}-\\d{2}_\\d{2}-\\d{2}-\\d{2}\\)/g, '')
			const ext = name.slice(lastDotIndex)
			newName = `${base} (${timestamp})${ext}`
		}
	}

	if (withWarning) {
		toastCaller({
			type: 'warning',
			message: `The ${
				isFolder ? 'folder' : 'file'
			} "${originalName}" already exists.\nIt will be renamed to "${newName}".`,
		})
	}

	return newName
}

// const getItemName = ({
// 	currentName,
// 	isFolder,
// 	withWarning,
// }: {
// 	currentName: string
// 	isFolder?: boolean
// 	withWarning?: boolean
// }) => {
// 	const list = itemsList?.filter(({ type }) => (isFolder ? !!type : !type))

// 	const getFileNameParts = (name: string) => {
// 		const lastDotIndex = name.lastIndexOf('.')
// 		if (lastDotIndex === -1) return { base: name, ext: '' }
// 		return {
// 			base: name.substring(0, lastDotIndex),
// 			ext: name.substring(lastDotIndex),
// 		}
// 	}

// 	const { base, ext } = getFileNameParts(currentName)
// 	const cleanBase = base.replace(/\s\(\d+\)$/, '')

// 	const existingNames = new Set(
// 		list?.map((file: DocumentData) => file?.name) ?? []
// 	)

// 	if (!existingNames.has(currentName)) return currentName

// 	let counter = 1
// 	let newName

// 	while (true) {
// 		newName = isFolder
// 			? `${cleanBase} (${counter})`
// 			: `${cleanBase} (${counter})${ext}`

// 		if (!existingNames.has(newName)) break

// 		counter++
// 	}

// 	if (withWarning) {
// 		toastCaller({
// 			type: 'warning',
// 			message: `The ${
// 				isFolder ? 'folder' : 'file'
// 			} "${currentName}" already exists!\nIt will be renamed to "${newName}".`,
// 		})
// 	}

// 	return newName
// }
